import React from 'react';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import { Entity } from '@backstage/catalog-model';
import { MarkdownContent } from '@backstage/core-components';
import { AboutField } from '@backstage/plugin-catalog';

type GuestAboutContentProps = {
  entity: Entity;
};

export const GuestAboutContent = ({ entity }: GuestAboutContentProps) => {
  const { description, tags = [] } = entity.metadata;
  const { type, lifecycle } = entity.spec ?? {};

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <AboutField label="Description">
          <MarkdownContent content={description || 'No description'} />
        </AboutField>
      </Grid>
      <Grid item xs={12}>
        <AboutField label="Tags" value="No Tags">
          {tags.map(tag => (
            <Chip key={tag} size="small" label={tag} />
          ))}
        </AboutField>
      </Grid>
      <Grid item xs={12} sm={4}>
        <AboutField label="Kind" value={entity.kind} />
      </Grid>
      {typeof type === 'string' && (
        <Grid item xs={12} sm={4}>
          <AboutField label="Type" value={type} />
        </Grid>
      )}
      {typeof lifecycle === 'string' && (
        <Grid item xs={12} sm={4}>
          <AboutField label="Lifecycle" value={lifecycle} />
        </Grid>
      )}
    </Grid>
  );
};
